import { render, staticRenderFns } from "./OrderOncecardDetail.vue?vue&type=template&id=2756af20&"
import script from "./OrderOncecardDetail.vue?vue&type=script&lang=js&"
export * from "./OrderOncecardDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderOncecardDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports